import { func_file } from 'functions';
import { useCustomSelector } from 'hooks';

export default function useExportData() {
    let {
        allOutletLogs
    } = useCustomSelector("outlet");

    function exportData() {
        // Set Header Names
        let headers = [
            [   
                "PERFORMED CATEGORY",
                "PERFORMED SYSTEM REMARK",
                "PERFORMED BY",
                "PERFORMED DATE",
                "PERFORMED TIME",
                "PERFORMED LOCATION",
                "PERFORMED LOCATION ID",
                "INT EXTEND 2",
            ]
        ];

        // Columns Widths
        let columnWidths = headers[0].map((header, idx) => {
            return {
                wch: idx == 1 || idx == 2? 50: header.length
            }
        });

        // Set rows data
        let rows = allOutletLogs.map((rowDetail) => {
            return [
                (rowDetail?.PERFORMED_CATEGORY? rowDetail.PERFORMED_CATEGORY: ""),
                (rowDetail?.PERFORMED_SYSTEM_REMARK? rowDetail.PERFORMED_SYSTEM_REMARK: ""),
                (rowDetail?.PERFORMED_BY? rowDetail.PERFORMED_BY: ""),
                (rowDetail?.PERFORMED_DATE? rowDetail.PERFORMED_DATE: ""),
                (rowDetail?.PERFORMED_TIME? rowDetail.PERFORMED_TIME: ""),
                (rowDetail?.PERFORMED_LOCATION? rowDetail.PERFORMED_LOCATION: ""),
                (rowDetail?.PERFORMED_LOCATION_ID? rowDetail.PERFORMED_LOCATION_ID: ""),
                (rowDetail?.INT_EXTEND_2? rowDetail.INT_EXTEND_2: ""),
            ]
        });

        func_file.generateFile_XLSX("Performed Journal Report", "Performed Journal", headers, rows, null, null, columnWidths);
    }

    return exportData;
}